// extracted by mini-css-extract-plugin
module.exports = {"container":"CheckContent_container__2wMmV","label":"CheckContent_label__3KZm4","newIcon":"CheckContent_newIcon__3oFDv"};